// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"KP-z","upvoteIcon":"LP-z","downvoteIcon":"MP-z","feedbackIcon":"NP-z"};